import MultiSelect from '@/components/common/MultiSelect'
import type { FC } from 'react'

interface SoundEffectListFiltersProps {
  tags: Record<string, number>
  onTagSelect: (selected: string[]) => void
  selectedTags: string[]
}

const SoundEffectListFilters: FC<SoundEffectListFiltersProps> = ({
  tags,
  onTagSelect,
  selectedTags,
}) => {
  return (
    <MultiSelect
      options={tags}
      onChange={onTagSelect}
      filterNameKey={'ls_filter_buttons_tags'}
      hasSelectAll
      initialSelected={selectedTags}
    />
  )
}

export default SoundEffectListFilters
